import { useMemo } from 'react';
import { useStartupPageFacade } from '@ideoz/core';

/**
 * Logic for the startup-entity profile: the startup facade plus identity-stable
 * initial form values (a fresh object each render would reset the form's input
 * on every keystroke via its `useEffect([initialValues])`).
 */
export function useStartupProfile(startupId: string) {
  const facade = useStartupPageFacade({ navigateToScope: () => {}, startupId });
  // The shell exposes the slim StartupDto; the facade's `startup` is the full
  // project entity — that's what the form needs.
  const project = facade.startup;

  const initialValues = useMemo(
    () => ({
      name: project?.name ?? '',
      project_type: project?.projectType ?? '',
      language: project?.language ?? '',
      industry: project?.industry ?? '',
      target_icp: project?.mainPersona ?? '',
      problem_details: project?.description ?? '',
    }),
    [
      project?.name,
      project?.projectType,
      project?.language,
      project?.industry,
      project?.mainPersona,
      project?.description,
    ]
  );

  return { project, initialValues, updateStartupInfo: facade.updateStartupInfo };
}
